export class Note {
	constructor(
		public id?: number,
		public idReq?: number,
		public userid?: number,
		public note?: string,
		// public collaborators?: Array<any>,
	) { }
}